import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, " Hallo Merve! ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", null, " Ich habe einige Rätsel verschiedener Themen für dich vorbereitet. ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", null, " Du kannst immer erst ein Rätsel lösen, wenn du das vorige gelöst hast. ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", null, " Die Rätsel erwarten immer nur eine einzige Antwort (Groß- und Kleinschreibung sind egal) und werden immer schwieriger und komplizierter je weiter du kommst. ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", null, " Bei Problemen kannst du natürlich auch gerne deine Freunde um Hilfe bitten. ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h4", null, " Wenn du nach drei Tagen bei einem Rätsel nicht weiterkommen solltest, wird ein Hinweis eingeblendet. ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h4", null, " Es gibt maximal zwei Hinweise pro Rätsel und du bekommst keine weitere Hilfe von mir (bin aber bestechlich). ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h4", null, " Viel Spaß wünsche ich dir / euch! ", -1)
const _hoisted_10 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_10))
}